module.exports = __webpack_public_path__ + "static/media/010-oval.021772d8.svg";